import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtherMedicalProfessionRoutingModule } from './other-medical-profession-routing.module';
import { MedicalProfessionSharedModule } from '../shared/medical-profession-shared.module';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { SharedModule } from '../../shared/shared.module';
import { OtherMedicalProfessionHomeComponent } from './other-medical-profession-home/other-medical-profession-home.component';
import { OtherMedicalProfessionEditComponent } from './other-medical-profession-edit/other-medical-profession-edit.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from '../../../services/shared/auth-interceptor.service';
import { PatientViewModule } from '../../shared/patient-view/patient-view.module';

@NgModule({
    declarations: [
        // OtherMedicalProfessionDashboardComponent,
        OtherMedicalProfessionHomeComponent,
        OtherMedicalProfessionEditComponent
    ],
    imports: [
        CommonModule,
        PrimengModule,
        OtherMedicalProfessionRoutingModule,
        SharedModule,
        MedicalProfessionSharedModule,
        HttpClientModule,
        PatientViewModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        }
    ]
})
export class OtherMedicalProfessionModule {}
